<template>
  <div class="card-guide">
    <block-shelf-resources
        :viewing-id="profile.userId"
        :apps="myApps"
        :display-app-icons="true"
    />
  </div>
</template>

<script>
import BlockShelfResources from "@/components/blockShelfResources";
export default {
  components: {
    BlockShelfResources
  },
  props: {
    profile: {
      type: Object,
      default: () => {}
    },
    provider: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    myApps() {
      return this.provider && this.provider.myApps && Array.isArray(this.provider.myApps) ?
          this.provider.myApps : [];
    }
  },
  methods: {
    limitWords() {
      document.getElementById("bio").setAttribute("maxlength", 300);
    },
    updateAccountOptions(options) {
      this.accountOptions = options;
    },
    toggleExpertise(e) {
      if (this.expertise.includes(e)) {
        let index = this.expertise.indexOf(e);
        this.expertise.splice(index, 1);
      } else {
        this.expertise.push(e);
      }
    },
    getNested({ obj, def }, ...args) {
      let truthy = args.reduce((obj, level) => obj && obj[level], obj);
      if (truthy) return truthy;
      else return def;
    },
    saveChanges() {
      let dataToUpdate = {
        blogger: {
          bio: this.bio,
          expertise: this.expertise,
          accountType: this.accountOptions[0].value,
          displayProfile: this.accountOptions[1].value
        }
      };
      this.$store
        .dispatch("user/updateProfileDashboardBlogger", dataToUpdate)
        .then(res => {
          if (res) {
            this.$store.dispatch("user/getProfile").then(() => {
              this.$store.dispatch("user/showNotification", {
                title: "Profile Info Updated Successfully",
                description: "Users will not see this info until you Publish.",
                variant: "success"
              });
            });
          }
        });
    }
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.dash-border {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' stroke='%23ddddddff' stroke-width='1' stroke-dasharray='3%2c 6' stroke-dashoffset='0' stroke-linecap='butt'/%3e%3c/svg%3e");
  height: 1px;
  margin-bottom: 10px;
}
#account_type {
  color: #677177;
}
.areas {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  & > div {
    width: 60px;
    h6 {
      font-style: normal;
      font-weight: normal;
      font-size: 12px;
      line-height: 16px;
      color: #8d99a0;
    }
    svg {
      cursor: pointer;
    }
  }
}
.profile-name {
  // position: relative;
  .btn-round-fill {
    width: 100%;
    height: 40px;
  }
  .back {
    position: absolute;
    top: 10px;
    left: 10px;
    cursor: pointer;
    padding: 4px;
    margin-top: 5px;
  }
  h1 {
    font-weight: 600;
    font-size: 24px;
    line-height: 33px;
    color: #474d52;
    text-align: center;
    margin: 0;
    // display: inline-block;
  }
  .desc {
    margin-top: 24px;
    margin-bottom: 28px;
    p {
      margin: 0;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      color: #474d52;
      text-align: center;
    }
    .btn-round-fill {
      margin-top: 28px;
    }
  }
}
input:disabled,
input[disabled] {
  background: #f3f6f9 !important;
  border-color: #f3f6f9 !important;
}
.foot {
  border-top: 1px solid #dddddd;
  padding: 16px;
}
.toggler {
  display: flex;
  justify-content: center;
  align-items: center;

  span {
    font-style: normal;
    font-weight: bold;
    font-size: 14px;
    line-height: 19px;
    color: #b3c2cb;
    &.active {
      color: var(--theme-color);
    }
  }
  .switch {
    margin: 0 8px;
    position: relative;
    display: inline-block;
    width: 62px;
    height: 32px;
  }

  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #fff;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .slider:before {
    position: absolute;
    content: "";
    height: 24px;
    width: 24px;
    left: 4px;
    bottom: 4px;
    background-color: var(--theme-color);
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  input:checked + .slider {
    background-color: #ddd;
  }

  input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  /* Rounded sliders */
  .slider.round {
    border-radius: 34px;
    background: #ddd;
  }

  .slider.round:before {
    border-radius: 50%;
  }
}
.half-width {
  display: inline-block;
  width: 50%;
}
.counter {
  margin-top: -18px;
  margin-right: 5px;
  font-size: 12px;
  float: right;
}
</style>
